import moment from 'moment-timezone';
export const TIMEZONE = 'Europe/London';
export default (() => {
    const DATE_FORMAT = 'D MMM YYYY h:mma';
    const DATE_FORMAT_SHORT = 'D MMM h:mma';
    const DATE_FORMAT_PICKER = 'YYYY-MM-DDTHH:mm';
    const picker = (timestamp) => moment.utc(timestamp).tz(TIMEZONE).format(DATE_FORMAT_PICKER);
    const standard = (timestamp) => moment.utc(timestamp).tz(TIMEZONE).format(DATE_FORMAT);
    const short = (timestamp) => moment.utc(timestamp).tz(TIMEZONE).format(DATE_FORMAT_SHORT);
    const timeAgo = (timestamp) => moment.utc(timestamp).fromNow();
    const now = () => moment().tz(TIMEZONE).format(DATE_FORMAT);
    const server = (date) => moment(date).utc().format(DATE_FORMAT_PICKER);
    return {
        standard,
        short,
        timeAgo,
        now,
        picker,
        server,
    };
})();
